<template>
  <div id="UserCreation">
    <!-- Logo area -->
    <el-row
      type="flex"
      class="logoWrap"
      :class="`${$mq}Mode`"
    >
      <el-col
        class="logoCol"
        :span="responsiveCol"
      >
        <div
          class="logo"
          @click="$router.push({name: 'login'}).catch((err) => {})"
        >
          <img
            src="@/assets/logo/gcg_logo.png"
            alt="logo"
          />
        </div>
      </el-col>

      <el-col
        v-if="$mq !== 'mobile'"
        class="sloganCol"
        :span="responsiveCol"
      >
        <div class="slogan">
          <img
            src="@/assets/logo/gcg_slogan.png"
            alt="logo"
          />
        </div>
      </el-col>
    </el-row>

    <CreateMemberForm
      class="card"
      :dialog-width="dialogWidth"
    />
  </div>
</template>

<script>
import DialogSetting from '@/mixins/dialog';
import CreateMemberForm from './CreateMemberForm.vue';

export default {
  components: {
    CreateMemberForm,
  },

  mixins: [DialogSetting],

  computed: {
    responsiveCol() {
      let col = 12;
      if (this.$mq === 'mobile') {
        col = 24;
      }
      return col;
    },
  },
};
</script>

<style lang="scss" scoped>
  #UserCreation {
    min-height: 100vh;
    padding: 0 5px 20px;

    .logoWrap {
      width: 100%;
      padding: 45px 5% 10px;
      display: block !important;

      .logoCol {
        .logo {
          img {
            width: 110px;
          }
        }
      }

      .sloganCol {
        text-align: right;

        .slogan {
          img {
            width: 180px;
          }
        }
      }

      &.mobileMode {
        padding: 30px 0;

        .logoCol {
          text-align: center;

          .logo {
            img {
              width: 100px !important;
            }
          }
        }
      }

      &.tabletMode {
        padding: 40px 5%;

        .logoCol {
          .logo {
            img {
              width: 100px !important;
            }
          }
        }

        .sloganCol {
          .slogan {
            img {
              width: 170px !important;
            }
          }
        }
      }
    }

    .card {
      margin-top: 50px;
    }
  }
</style>
